export default {
  list: state => state.list,
  profiles: state => state.profiles,
  enterprises: state => state.enterprises,
  errors: state => state.errors,
  agent: state => state.agent
};
